<template>
  <input :value="value"
         :name="name"
         :id="id"
         :class="{'error': errors.length > 0}"
         type="text"
         autocomplete="off">
</template>

<script>
import $ from 'jquery'
import '../../vendor/xc-website/static/bower_components/intl-tel-input/lib/libphonenumber/build/utils'
import '../../vendor/xc-website/static/bower_components/intl-tel-input'
import '../../vendor/xc-website/static/bower_components/intl-tel-input/build/css/intlTelInput.css'

export default {
  name: 'IntlTelField',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  mounted: function () {
    this.initPlugin()
  },
  updated: function () {
    $(this.$el).intlTelInput('setNumber', this.value)
  },
  beforeDestroy: function () {
    this.destroyPlugin()
  },
  methods: {
    destroyPlugin: function () {
      $(this.$el).intlTelInput('destroy')
    },
    initPlugin: function () {
      const component = this
      const $field = $(this.$el)
      $field.intlTelInput({
        onlyCountries: ['be', 'de', 'nl'],
        preferredCountries: ['nl'],
        autoFormat: true,
        allowExtensions: false,
        autoPlaceholder: true,
        defaultCountry: '',
        ipinfoToken: '',
        nationalMode: true
      })

      // on blur: validate
      $field.blur(function () {
        const valid = $field.intlTelInput('isValidNumber')
        const value = valid ? $field.intlTelInput('getNumber') : $field.val()
        component.$emit('change', value)
        if ($.trim(value)) {
          if (valid) {
            $field.removeClass('error')
          } else {
            $field.addClass('error')
          }
        }
      })

      // on keydown: reset
      $field.keydown(function () {
        $field.removeClass('error')
        component.$emit('keydown')
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/IntlTelField.vue